<template>
  <div class="device-type-container">
    <el-card class="box-card">
      <div class="search-area">
        <el-form ref="queryForm" :model="queryParams" label-width="70px" inline size="small">
          <el-form-item label="车锁类型:">
            <el-select v-model="queryParams.bicycleType" placeholder="请选择" clearable style="width: 120px;">
              <el-option label="自行车锁" :value="1"></el-option>
              <el-option label="电动车锁" :value="2"></el-option>
              <el-option label="涨闸锁" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型名称:">
            <el-input v-model="queryParams.deviceTypeName" placeholder="请输入类型名称" clearable style="width: 150px;" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetQuery">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增车辆类型</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="table-container">
        <el-table :data="configList" border stripe :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }" v-loading="loading">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="bicycleType" label="车锁类型" width="120">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.bicycleType === 1" type="success" size="small">自行车锁</el-tag>
              <el-tag v-else-if="scope.row.bicycleType === 2" type="primary" size="small">电动车锁</el-tag>
              <el-tag v-else-if="scope.row.bicycleType === 3" type="warning" size="small">涨闸锁</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="deviceTypeName" label="车辆类型名称" min-width="150"></el-table-column>
          <el-table-column prop="sortOrder" label="排序"></el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 1" type="success" size="small">启用</el-tag>
              <el-tag v-else type="danger" size="small">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
          <el-table-column label="操作" width="180" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px;"
        ></el-pagination>
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" append-to-body>
      <el-form ref="configForm" :model="configForm" :rules="configRules" label-width="100px">
        <el-form-item label="车锁类型:" prop="bicycleType">
          <el-select v-model="configForm.bicycleType" placeholder="请选择车锁类型" style="width: 100%;">
            <el-option label="自行车锁" :value="1"></el-option>
            <el-option label="电动车锁" :value="2"></el-option>
            <el-option label="涨闸锁" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车辆类型名称:" prop="deviceTypeName">
          <el-input v-model="configForm.deviceTypeName" placeholder="请输入车辆类型名称" />
        </el-form-item>
        <el-form-item label="排序:" prop="sortOrder">
          <el-input-number v-model="configForm.sortOrder" :min="0" :max="999" />
        </el-form-item>
        <el-form-item label="状态:" prop="status" v-if="isEdit">
          <el-radio-group v-model="configForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DeviceTypeConfig',
  data() {
    return {
      loading: false,
      isAdmin: false,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        distributorId: '',
        bicycleType: null,
        deviceTypeName: ''
      },
      distributorOptions: [],
      configList: [],
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      configForm: {
        id: '',
        distributorId: '',
        bicycleType: null,
        deviceTypeName: '',
        deviceTypeCode: '',
        sortOrder: 0,
        status: 1
      },
      configRules: {
        distributorId: [{ required: true, message: '请选择运营商', trigger: 'change' }],
        bicycleType: [{ required: true, message: '请选择车锁类型', trigger: 'change' }],
        deviceTypeName: [{ required: true, message: '请输入车辆类型名称', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.checkAdmin()
    this.getDistributorOptions()
    this.getList()
  },
  methods: {
    checkAdmin() {
      this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true'
    },
    getDistributorOptions() {
      this.$http.get('/distributor/manager/getAllDistributorInfo').then(res => {
        if (res.data.code === 200) {
          this.distributorOptions = res.data.data || []
        }
      })
    },
    getList() {
      this.loading = true
      const params = {
        page: this.queryParams.pageNum,
        limit: this.queryParams.pageSize,
        distributorId: this.queryParams.distributorId,
        bicycleType: this.queryParams.bicycleType,
        deviceTypeName: this.queryParams.deviceTypeName
      }
      this.$http.post('/device/typeConfig/getPageInfo', params).then(res => {
        this.loading = false
        if (res.data.code === 200) {
          this.configList = res.data.data.list || []
          this.total = res.data.data.total || 0
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        distributorId: '',
        bicycleType: null,
        deviceTypeName: ''
      }
      this.getList()
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
      this.getList()
    },
    handleAdd() {
      this.dialogTitle = '新增车辆类型'
      this.isEdit = false
      this.configForm = {
        id: '',
        distributorId: '',
        bicycleType: null,
        deviceTypeName: '',
        deviceTypeCode: '',
        sortOrder: 0,
        status: 1
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑车辆类型'
      this.isEdit = true
      this.configForm = { ...row }
      this.dialogVisible = true
    },
    handleDelete(row) {
      this.$confirm('确定要删除该车辆类型配置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.get(`/device/typeConfig/delete/${row.id}`).then(res => {
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {})
    },
    submitForm() {
      this.$refs.configForm.validate(valid => {
        if (valid) {
          const url = this.isEdit ? '/device/typeConfig/update' : '/device/typeConfig/add'
          this.$http.post(url, this.configForm).then(res => {
            if (res.data.code === 200) {
              this.$message.success(this.isEdit ? '修改成功' : '添加成功')
              this.dialogVisible = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.device-type-container {
}

.box-card {
}

.search-area {
  margin-bottom: 15px;
}

.table-container {
  margin-top: 15px;
}
</style>
